<template>
  <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
    <template v-slot:searchDiv>
      <div class="secondSearchLine">
        <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
      </div>
    </template>
    <template v-slot:contentDiv>
      <div v-for="(item,index) in dataList" :key="index">
        <div v-if="item.productType==2">
          <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
        </div>
        <div v-else class="contentDiv">
          <hotel-resource-left :productObj="item" :showTag="false" :btnName="'加入行程'" :btnName1="'询'" class="contentHead">
          </hotel-resource-left>
          <div class="contentContainer" v-if="item.isOpen">
            <div class="boxContainer1">
              <div  v-for="(item1, index1) in item.stockListResults" :key="index1">      
                <div class="firstLine">
                  <el-tooltip placement="top">
                    <div slot="content">{{item1.productNameCn}}</div>
                    <label class="productName">{{item1.productNameCn}}</label>
                  </el-tooltip>
                  <el-tooltip placement="top">
                    <div slot="content">{{item1.productDesc}}</div>
                    <label class="productName" style="font-weight: normal;width:2rem">{{item1.productDesc}}</label>
                  </el-tooltip>
                  <label style="width: 0.5rem;">{{item1.cancelType==1?"不可取消":item1.cancelType==5?"随时退":item1.cancelType==6?"过期退":"有条件退"}}</label>
                  <label class="label" v-for="(item3,index) in item1.labels" :key="index">{{item3}}</label>
                  <svg-icon :iconClass="'arrow-down'"></svg-icon>
                  <span style="font-size: 0.18rem;width: 0.5rem;">{{item1.priceList[0].price}}{{item1.priceList[0].currency}}</span>
                  <el-input v-model="item1.checkNumber" style="width: 0.5rem" size="mini"></el-input>
                  <label>&nbsp;{{item1.priceList[0].priceCompany}}</label>
                  <div class="item3">
                    <span class="qiang" >抢</span>
                    <i class="el-icon-circle-plus-outline" @click="addBudget(item,item1)"></i>
                  </div>
                </div>
              </div>
            </div>
            <p style="text-align: right">
              <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
            </p>
          </div>
        </div>
      </div>
    </template>
  </stock>
</template>

<script>
import Stock from './stock.vue'
import Api from '@/components/Api/index.js'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import { refresh } from '../../js/function'
export default {
  components:{Stock,hotelResourceLeft},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:null,
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:8,
      },
      dataList:[],
      keyStr:'',
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    postListData(type){
      if(this.checkState===8){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      } 
    },
    addBudget(item,item1){
      var arr = [{
        stockId:item1.stockId,
        stockNumber:item1.checkNumber
      }]
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:8,
        startLinkId:this.searchObj.cityId,
        startLinkName:this.searchObj.cityNameCn,
        startLinkNameEn:this.searchObj.cityNameEn,
        linkType:1,
        stayDate:this.searchObj.date,
        productType:item.productType,
        resourceId:item.id,
        resourceNameCn:item.nameCn,
        resourceNameEn:item.nameEn,
        key:this.keyStr,
        details:arr
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentContainer{
    .boxContainer1{
      padding: 0.1rem;
      font-size: 0.12rem;
      .firstLine{
        display: flex;
        align-items: center;
        margin-bottom: 0.1rem;
        >label{
          margin-right: 0.05rem;
        }
        .label{
          padding: 0.02rem 0.05rem;
          color: #fcca00;
          border: 1px solid #fcca00;
          font-weight: normal;
        }
        >span{
          font-size: 0.14rem;
          color: #ca000b;
          font-weight: bold;
          margin:0 0.05rem;
        }
        i{
          font-size: 0.28rem;
        }
        .item3{
          display: flex;
          margin-left: 0.1rem;
          .qiang{
            font-size: 0.18rem;
            box-shadow: 0px 0px 4px 0px #333;
            border-radius: 50%;
            color: red;
            text-align: center;
            display: inline-block;
            width: 0.26rem;
            height: 0.26rem;
            margin-right: 0.05rem;
            line-height: 0.26rem;
            font-weight: bold;
            vertical-align: middle;
          }
          >i{
            font-size: 0.28rem;
          }
        }
      }
      .productName{
        color: #000;
        font-weight: bold;
        margin-right: 0.1rem;
        width: 1.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>